import DatePicker from './src/picker/date-picker';

export default DatePicker;
